import TabLayout from "../components/common/TabLayout";

function TabSample() {
    return (
        <>
            <TabLayout>
                <div className="p-4">리액트 탭 샘플입니다.</div>
            </TabLayout>
        </>
    );
}
export default TabSample;